<template>
    <!-- 入口(客服技能组)弹窗 -->
    <van-popup v-if="isMobile" v-model="show" position="bottom" round class="mb-the_skill_group">
        <div class="hd"><span>请选择</span><i class="close" @click="show = false" /></div>
        <div class="wrapper">
            <div class="entrance" v-for="o in list" :key="o.id" @click="artificialService(o.id)">
                <!-- <img class="entrance__icon" /> -->
                <div class="entrance__name">{{ o.name }}</div>
            </div>
        </div>
    </van-popup>
    <van-popup v-else v-model="show" position="right" class="pc-the_skill_group">
        <i class="close el-icon-close" @click="show = false" />
        <div class="hd">请选择</div>
        <div class="wrapper">
            <div
                class="cell"
                v-for="o in list"
                :key="o.id"
                @click="artificialService(o.id)"
            >{{ o.name }}</div>
        </div>
    </van-popup>
</template>

<script>
    import { Popup } from 'vant'
    import { skillGroups, turnHumanService } from '@/api/skill_group'
    import { MESSAGE_NAME } from '@/constants/message'
    import { sendMessage } from '@/utils/message_send'

    export default {
        components: {
            [Popup.name]: Popup
        },
        data () {
            return {
                loading: false,
                list: []
            }
        },
        computed: {
            show: {
                get () {
                    return this.$store.state.skill_group.pop
                },
                set (value) {
                    this.$store.commit('setSkillGroup', {
                        key: 'pop',
                        value
                    })
                }
            },
            isMobile () {
                return this.$eventBus.isMobile
            }
        },
        watch: {
            show (b) {
                if (b) this.init()
            }
        },
        methods: {
            async init () {
                this.list = await skillGroups()
                this.$store.commit('setSkillGroup', {
                    key: 'list',
                    value: this.list
                })
            },
            artificialService (group_id) {
                // 正在转人工中...
                if (this.$store.state.skill_group.group_id) return

                // 技能客服组开启转人工：先开启会话完成后，再发送group_id转人工
                this.$store.commit('setSkillGroup', {
                    key: 'group_id',
                    value: group_id
                })

                // 开启会话
                sendMessage({
                    type: 'base',
                    detailType: MESSAGE_NAME.TEXT,
                    content: '人工'
                })
            },
            // 转人工
            sendHumanService () {
                const { group_id } = this.$store.state.skill_group
                if (!group_id) return

                if (this.loading) return
                
                this.loading = true
                turnHumanService({
                    group_id,
                    chat_user_id: this.$eventBus.uid
                }).then(() => {
                    this.show = false
                    this.loading = false
                }).catch(() => {
                    this.loading = false
                })

                this.$store.commit('setSkillGroup', {
                    key: 'group_id',
                    value: ''
                })
            }
        }
    }
</script>

<style lang="scss">
// 移动端弹窗
$padding: 20px;
.mb-the_skill_group {
    display: flex;
    flex-direction: column;
    height: 50%;
    padding-bottom: 20px;
    .hd {
        display: flex;
        align-items: center;
        padding: 13px $padding;
        span {
            flex: 1;
            color: #252628;
        }
    }
    .close {
        display: inline-block;
        width: 22px;
        height: 22px;
        background: url('~@/assets/img/close.svg') no-repeat left center/contain;
    }
    .wrapper {
        overflow-y: auto;
        display: flex;
        flex-wrap: wrap;
        padding: 0 $padding;
    }
    .entrance {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // width: 162px;
        width: 48.5%;
        height: 56px;
        padding: 12px;
        border-radius: 8px;
        background: #EBEDF0;
        &:nth-of-type(even) {
            margin-left: 8px;
        }
        &:nth-of-type(n + 3) {
            margin-top: 10px;
        }
    }
    .entrance__icon {
        width: 40px;
        height: 40px;
        margin-right: 8px;
        border-radius: 50%;
        background: #fff;
    }
    .entrance__name {
        flex: 1;
        font-size: 13px;
    }
}

// pc端弹窗
.pc-the_skill_group {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 300px;
    height: 100%;
    &.van-popup {
        overflow: initial;
    }
    .hd {
        display: flex;
        align-items: center;
        padding: 15px $padding;
        font-size: 16px;
        font-weight: bold;
        color: #333;
        &:before {
            content: '';
            display: inline-block;
            width: 2px;
            height: 15px;
            margin-right: 5px;
            background: #333;
        }
    }
    .wrapper {
        overflow-y: auto;
    }
    .cell {
        height: 56px;
        margin: 0 $padding 10px;
        padding: 15px;
        border-radius: 7px;
        background: #F5F6F8;
        cursor: pointer;
        &:first-child {
            margin-top: 5px;
        }
    }
    .close {
        position: absolute;
        top: 0;
        left: -20px;
        width: 20px;
        height: 20px;
        color: #fff;
        font-size: 20px;
        background: #a7aab1;
        cursor: pointer;
    }
}
</style>